<template>
    <div id="about" class="container h-100">
        <LoginHeader class="text-center"/>
        <p class="text-center">Version: {{this.$store.state.version}}</p>
        <div class="row align-items-center text-center ">
            <div class="col-12 p-m-5">
                <div class="m-5">
                    <h3>{{$t("general.welcome")}}</h3>
                    <h6>{{$t("general.description")}}</h6>
                    <br>
                    <a href="https://kalamaio.com/?ref=kvip-about')" target="_blank">{{$t("messages.discovermoreon")}} <b>Kalamaio.com</b></a>
                </div>
            </div>
            <div class="col-12">
            </div>
            <footer class="col-12">
                <router-link class="col" to="Home">{{$t("backhome")}}</router-link>
            </footer>
        </div>
    </div>
</template>

<style>
    #about {
        background: #06424d;
        min-height: 100%;
        color: white;
        min-width: 100%;
    }
</style>

<script>
import LoginHeader from '../components/LoginHeader.vue';

export default {
    components: {
        LoginHeader
    },
    methods: {
        goTo(url) {
            window.open(url, '_blank');
        }
    },
    i18n: {
        messages: {
            en: {
                backhome: 'Back to Home'
            },
            it: {
                backhome: 'Torna alla Home'
            }
        }
    }
};
</script>
